import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Scale, GraduationCap, Clock, Bot } from 'lucide-react';
export const Audience = () => {
  const audience = [{
    icon: <Briefcase className="w-5 h-5" data-id="element-17" data-mp="6uzo4bd92ar1" />,
    text: 'Abogados independientes.'
  }, {
    icon: <Users className="w-5 h-5" data-id="element-18" data-mp="1vda3zplkqh6" />,
    text: 'Estudios jurídicos.'
  }, {
    icon: <GraduationCap className="w-5 h-5" data-id="element-19" data-mp="gsdqx869310v" />,
    text: 'Profesionales recién recibidos.'
  }, {
    icon: <Clock className="w-5 h-5" data-id="element-20" data-mp="bum1ckt2vqzu" />,
    text: 'Abogados con experiencia que buscan optimizar su trabajo.'
  }, {
    icon: <Bot className="w-5 h-5" data-id="element-21" data-mp="pkphqv5a0qhd" />,
    text: 'Quienes desean incorporar IA jurídica a su práctica.'
  }, {
    icon: <Scale className="w-5 h-5" data-id="element-22" data-mp="llqdzdva6zri" />,
    text: 'Profesionales que quieren captar más clientes y organizar mejor su estudio.'
  }];
  return <section className="py-12 bg-legal-900" data-id="element-23" data-mp="ul3f9j994i15">
      <div className="container mx-auto px-4" data-id="element-24" data-mp="um4zad88wev0">
        <div className="max-w-4xl mx-auto" data-id="element-25" data-mp="16dhxvb7p16lm">
          <div className="text-center mb-12" data-id="element-26" data-mp="16eswkwma7o5v">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-27" data-mp="1bbjc9iu6chqr">
              ¿Para quién es este Megapack?
            </h2>
            <p className="text-lg text-slate-400" data-id="element-28" data-mp="1g9umhuodsu9i">
              Este sistema fue creado específicamente para potenciar la práctica
              legal diaria.
            </p>
          </div>

          <div className="bg-legal-800 rounded-2xl p-8 md:p-12 border border-legal-700 shadow-xl" data-id="element-29" data-mp="1pbaww2f74wdq">
            <ul className="space-y-6 mb-10" data-id="element-30" data-mp="1u9chwsw6n5ru">
              {audience.map((item, idx) => <motion.li key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: idx * 0.1
            }} className="flex items-start gap-4 text-slate-300 text-lg" data-id="element-31" data-mp="1z2ymdxs703ck" data-mpi={idx}>
                  <div className="mt-1 p-1.5 bg-legal-900 text-gold-500 rounded-md shrink-0" data-id="element-32" data-mp="mq0dxtuflz8t">
                    {item.icon}
                  </div>
                  <span className="leading-relaxed" data-id="element-33" data-mp="hwfc1qppwl4c">{item.text}</span>
                </motion.li>)}
            </ul>

            <div className="bg-legal-900/50 border-l-4 border-gold-500 p-6 rounded-r-lg" data-id="element-34" data-mp="rol22uwessgw">
              <p className="text-slate-300 font-medium italic" data-id="element-35" data-mp="15nkpy0c3l3c0">
                No importa si recién comenzás en la profesión o si ya tenés años
                de experiencia: el objetivo es brindarte herramientas concretas
                para trabajar con mayor seguridad, rapidez y respaldo jurídico.
                📚✨
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};